// extracted by mini-css-extract-plugin
export default {"container":"EmptyState_container--Jjk","text":"EmptyState_text--pHN","subText":"EmptyState_subText--CaF"};